import { eNetworkName } from "app/services/contract/contract.config";

export const subgraphChainName = (chainName: eNetworkName): string => {
    switch (chainName) {
        case eNetworkName.bsc:
            return 'kryptomondao-kryptomon';
            break;
        case eNetworkName.chapel:
            return 'kryptomon-chapel';
            break;
        case eNetworkName.mumbai:
            return 'kryptomon-mumbai';
            break;
        case eNetworkName.polygon:
            return 'kryptomon-polygon';
            break;

        default:
            return 'kryptomon-polygon';
            break;
    }
}